module.exports = __webpack_public_path__ + "media/EasyBase.32c1554b.mp4";